import * as Styled from "./Switches.styles";

import { LocationFlag, useLocationFlags } from "context/LocationFlagsContext";
import { useCallback, useEffect, useState } from "react";

import { Switch } from "antd";
import { useCRM } from "context/CRMContext";
import { useCheckMatch } from "context/CheckMatchContext";
import { useLocation } from "context/LocationContext";
import { useTableStatus } from "context/TableStatusContext";

function Switches() {
  const [isToastChitsEnabled, setIsToastChitsEnabled] = useState(false);

  const { handleUpdateTableStatusEnabled, isTableStatusEnabled } = useTableStatus();
  const { handleUpdateCheckMatchEnabled, updateCheckMatchMappingsEnabled, isCheckMatchEnabled } = useCheckMatch();
  const { handleUpdateCRMEnabled, isCRMEnabled } = useCRM();
  const { currentLocation } = useLocation();
  const isNonPosLocation = currentLocation?.posType === "non-pos";
  const posType = currentLocation?.posType;

  const { checkIfFlagIsEnabled, locationFlags, updateLocationFlags } = useLocationFlags();

  const handleTableStatusChange = (checked: boolean) => {
    handleUpdateTableStatusEnabled(checked);
  };

  const handleCheckMatchEnabled = (checked: boolean) => {
    handleUpdateCheckMatchEnabled(checked);
    updateCheckMatchMappingsEnabled(checked);
  };

  const handleCRMUpdateEnabled = (checked: boolean) => {
    handleUpdateCRMEnabled(checked);
  };

  useEffect(() => {
    locationFlags && setIsToastChitsEnabled(checkIfFlagIsEnabled("toast-chits.enabled"));
  }, [checkIfFlagIsEnabled, locationFlags]);
  
  const handleToastChitsEnabled = useCallback(
    () => {
      const updatedLocationFlags: LocationFlag[] = [
        {
          name: "toast-chits.enabled",
          enabled: !isToastChitsEnabled,
        },
      ];

      setIsToastChitsEnabled(!isToastChitsEnabled);
      void updateLocationFlags(updatedLocationFlags);  
    },
    [isToastChitsEnabled, updateLocationFlags],
  );
  

  return (
    <Styled.Container>
      <Styled.Card>
        Table Status
        <Switch
          id="table-status"
          checked={isTableStatusEnabled}
          onChange={handleTableStatusChange}
          data-testid="table-status-switch"
          disabled={isNonPosLocation}
        />
      </Styled.Card>
      <Styled.Card>
        Check Match
        <Switch
          id="check-match"
          checked={isCheckMatchEnabled}
          onChange={handleCheckMatchEnabled}
          data-testid="check-match-switch"
          disabled={isNonPosLocation}
        />
      </Styled.Card>
      <Styled.Card>
        CRM
        <Switch
          id="crm"
          checked={isCRMEnabled}
          onChange={handleCRMUpdateEnabled}
          data-testid="crm-switch"
        />
      </Styled.Card>
      {posType === "toast" && <Styled.Card>
        Toast Chits
        <Switch
          id="toast-chits"
          checked={isToastChitsEnabled}
          onChange={handleToastChitsEnabled}
          data-testid="toast-chits-switch"
        />
      </Styled.Card>}
    </Styled.Container>
  );
}

export default Switches;
